:host 
  display: block
  margin: 1rem !important
  margin-bottom: 1rem !important

